import React from 'react';
import { cn } from "@/lib/utils";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";

type NavigationProps = React.HTMLAttributes<HTMLDivElement>;

const navigationItems = [
  { title: "Home", path: "/" },
  { title: "About", path: "/about/" },
  { title: "Team", path: "/about/our-team/" },
  { title: "Treatments", path: "/treatments/" },
  { title: "News & Articles", path: "/news-and-articles" },
  { title: "Cost", path: "/patient-resources/pricing/" },
  { title: "Service Areas", path: "/service-areas" },
  { title: "Specials", path: "/specials" },
  { title: "Contact Us", path: "/contact" },
];

const NavItem = ({ item }) => {
  const location = useLocation();

  return (
    <Link
      to={item.path}
      className={cn(
        "block px-4 py-2.5 text-sm transition-gentle rounded-lg transform hover:scale-[1.02] relative overflow-hidden",
        "hover:gradient-accent hover:text-accent-foreground active:gradient-accent-hover",
        location.pathname === item.path && "gradient-primary text-primary-foreground font-medium shadow-medium"
      )}
    >
      <span className="relative z-10">{item.title}</span>
      {location.pathname === item.path && (
        <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-transparent animate-fade-in"></div>
      )}
    </Link>
  );
};

export function Navigation({ className }: NavigationProps) {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="group flex items-center justify-center hover:gradient-accent hover:text-accent-foreground transition-gentle transform hover:scale-110"
          aria-label="Open navigation menu"
        >
          <Menu className="h-6 w-6 transition-gentle group-hover:scale-110 group-hover:rotate-180" />
          <span className="sr-only">Toggle navigation menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent
        side="left"
        className="w-[300px] sm:w-[400px] lg:w-[500px] overflow-y-auto border-r animate-slide-in-left"
      >
        <div className="mb-4">
          {/* <h2 className="text-lg font-semibold mb-2">Menu</h2>
          <p className="text-sm text-muted-foreground">
            Explore our services and treatments
          </p> */}
        </div>
        <nav className={cn("flex flex-col space-y-6", className)}>
          {navigationItems.map((item, index) => (
            <div key={index} className="animate-fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
              <NavItem item={item} />
            </div>
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
}
